<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="申请人名称" prop="applyName">
          <el-input v-model="dataForm.applyName" placeholder="申请人名称"></el-input>
      </el-form-item>
          <el-form-item label="渠道号" prop="channelNum">
          <el-input v-model="dataForm.channelNum" placeholder="渠道号"></el-input>
      </el-form-item>
          <el-form-item label="企业名称" prop="customerName">
          <el-input v-model="dataForm.customerName" placeholder="企业名称"></el-input>
      </el-form-item>
          <el-form-item label="授信状态" prop="limitStatus">
          <el-input v-model="dataForm.limitStatus" placeholder="授信状态"></el-input>
      </el-form-item>
          <el-form-item label="申请时间" prop="applyTime">
          <el-input v-model="dataForm.applyTime" placeholder="申请时间"></el-input>
      </el-form-item>
          <el-form-item label="授信信息" prop="limitTime">
          <el-input v-model="dataForm.limitTime" placeholder="授信信息"></el-input>
      </el-form-item>
          <el-form-item label="授信额度" prop="limitAmount">
          <el-input v-model="dataForm.limitAmount" placeholder="授信额度"></el-input>
      </el-form-item>
          <el-form-item label="授信到期日" prop="limitEndTime">
          <el-input v-model="dataForm.limitEndTime" placeholder="授信到期日"></el-input>
      </el-form-item>
          <el-form-item label="渠道号" prop="secChannelNum">
          <el-input v-model="dataForm.secChannelNum" placeholder="渠道号"></el-input>
      </el-form-item>
          <el-form-item label="团队长邀请码" prop="yrymCaptainCode">
          <el-input v-model="dataForm.yrymCaptainCode" placeholder="团队长邀请码"></el-input>
      </el-form-item>
          <el-form-item label="推荐官邀请码" prop="yrymInvitationCode">
          <el-input v-model="dataForm.yrymInvitationCode" placeholder="推荐官邀请码"></el-input>
      </el-form-item>
          <el-form-item label="管理员邀请码" prop="yrymAdminCode">
          <el-input v-model="dataForm.yrymAdminCode" placeholder="管理员邀请码"></el-input>
      </el-form-item>
          </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        applyName: '',
        channelNum: '',
        customerName: '',
        limitStatus: '',
        applyTime: '',
        limitTime: '',
        limitAmount: '',
        limitEndTime: '',
        secChannelNum: '',
        yrymCaptainCode: '',
        yrymInvitationCode: '',
        yrymAdminCode: '',
        creator: '',
        createDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        applyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelNum: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        customerName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        applyTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitEndTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        secChannelNum: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        yrymCaptainCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        yrymInvitationCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        yrymAdminCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/nbbankquery/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/nbbankquery/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
